import { PlanItem } from "../../plan.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { AbstractTreatment } from "../treatment";
import { TreatmentPriceConfiguration } from "../../../../price/price.model";

export class ExternalBleach extends AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    const resolvedConditions = ["discolored"];

    odontogram
      .filter((tooth) => !tooth.missing)
      .forEach((tooth) => {
        tooth.diagnosis = tooth.diagnosis.filter(
          (diagnosis) => !resolvedConditions.includes(diagnosis.condition),
        );
        tooth.plan.push({ treatment: item.treatment });
      });

    return odontogram;
  }

  static getPriceConfiguration(): TreatmentPriceConfiguration {
    return {
      type: "simple",
      single: true,
      identifier: this.getIdentifier(),
    };
  }

  static getIdentifier(): string {
    return "external-bleach";
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/restorative/external-bleach.ts